import { render, staticRenderFns } from "./ModalDemo.vue?vue&type=template&id=2aec1909&scoped=true&"
import script from "./ModalDemo.vue?vue&type=script&lang=js&"
export * from "./ModalDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aec1909",
  null
  
)

export default component.exports